import { createRoot } from "react-dom/client";

// Web host global styles: Tailwind base/components/utilities + the global
// design-system tokens and reset, plus the shared chat/card CSS for the
// app-core ConversationFeed (the `.app-team-chat-*` rules). ./index.css
// @imports "@sitebuilder/app-styles/index.css" first, so the side-effect
// stylesheet still loads; the package is marked sideEffects:["*.css"] so it
// survives tree-shaking. Shared surfaces consume the canonical global tokens
// defined there directly.
import "./index.css";

// Approved Indie typeface — Inter Variable, including Cyrillic.
// Loaded once for both the public site and every token-driven /app surface.
import "@fontsource-variable/inter";

import WebApp from "@/app/WebApp";

// The authenticated runtime config is intentionally loaded inside the lazy
// AuthenticatedApp boundary. Public routes never download app-core, query/data
// adapters, or desktop runtime setup.

export function bootstrapWeb(): void {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("web_root_element_missing");
  }

  createRoot(rootElement).render(<WebApp />);
}
